"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetVersionWarning = exports.InactivityCountdown = void 0;
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const immutable_1 = require("immutable");
const luxon_1 = require("luxon");
const query_string_1 = __importDefault(require("query-string"));
const uuid_1 = require("uuid");
const styled_components_1 = __importDefault(require("styled-components"));
const DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const auth_1 = require("companion-app-components/flux/auth");
const profile_1 = require("companion-app-components/flux/profile");
const core_1 = require("companion-app-components/utils/core");
const root_ui_1 = require("companion-app-components/flux/root-ui");
const ConfirmationDialog_1 = require("components/Dialogs/ConfirmationDialog");
const useQPreferences_1 = __importDefault(require("components/QPreferences/useQPreferences"));
const QHelp_1 = __importDefault(require("components/QHelp"));
const utils_1 = require("utils/utils");
const compose_1 = __importDefault(require("utils/compose"));
const versionDisplay_1 = __importDefault(require("./versionDisplay"));
const log = (0, core_1.getLogger)('components/Main/index.tsx');
exports.InactivityCountdown = styled_components_1.default.div `
  font-size: 40px;
  font-weight: bold;
  text-align: center;
  margin-top: 20px;
`;
let versionWarningGiven = false;
function resetVersionWarning() {
    versionWarningGiven = false;
}
exports.resetVersionWarning = resetVersionWarning;
function meetsMinimumVersionReqs(v1, minVer) {
    // prevent a crash, tell user to fix their profile :-)
    if (!v1 || !minVer) {
        return false;
    }
    const v1Parts = v1.split('.');
    const v2Parts = minVer.split('.');
    let retVal;
    let index = 0;
    while (index < v1Parts.length && retVal === undefined) {
        if (Number(v1Parts[index]) !== Number(v2Parts[index])) {
            retVal = Number(v1Parts[index]) > Number(v2Parts[index]);
        }
        index += 1;
    }
    // equality (still undefined) means strings are equal, and requirements are met
    return retVal === undefined ? true : retVal;
}
const inactivityTimeoutInSeconds = ((_a = (0, core_1.getBuildConfig)()) === null || _a === void 0 ? void 0 : _a.inactivity_timeout_in_seconds) || 900;
const inactivityCountdownTimeoutInSeconds = ((_b = (0, core_1.getBuildConfig)()) === null || _b === void 0 ? void 0 : _b.inactivity_countdown_timeout_in_seconds) || 30;
let inactivityExpirationTime = null;
let inactivityExpirationChecker = null;
let inactivityCountdownUpdater = null;
let inactivityCountdownValue = -1;
let inactivityCountdownDialogId = null;
const Main = (props) => {
    const { datasetPreferences, setDatasetPreference } = (0, useQPreferences_1.default)();
    const isLoggedIn = (0, react_redux_1.useSelector)((state) => auth_1.authSelectors.getAuthSession(state).accessToken);
    const profile = (0, react_redux_1.useSelector)((state) => profile_1.profileSelectors.getProfile(state));
    const featureFlags = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlags(state));
    const checkDesktopMinVersion = featureFlags.get('checkDesktopMinVersion');
    const minWindowsBuildNumber = featureFlags.get('minWindowsBuildNumber');
    const minMacReleaseNumber = featureFlags.get('minMacReleaseNumber');
    const dispatch = (0, react_redux_1.useDispatch)();
    const authLogout = (data, meta) => dispatch(auth_1.authActions.authLogout(data, meta));
    const createDialog = (rootUiData) => dispatch(root_ui_1.rootUiActions.createDialog(rootUiData));
    const updateDialogProps = (dialogProps) => dispatch(root_ui_1.rootUiActions.updateDialogProps(dialogProps));
    const inKioskmode = datasetPreferences.kioskmode;
    // this is a kiosk hack, if you add ?kioskmode to the URL, it will disable the
    // inactivity timeout, but only for that app session (module existence).  If this module
    // is reloaded (i.e. refresh page) and kioskmode is not in the URL at that point, it will
    // re-enable the timeout.  Currently the app does not preserve arbitrary url parms across pages.
    const queryObj = query_string_1.default.parse(window.location.search);
    if ('kioskmode' in queryObj) {
        setDatasetPreference({ kioskmode: Boolean(queryObj.kioskmode === 'enabled') });
        log.log(`Setting Kiosk Mode to ${String(queryObj.kioskmode === 'enabled')}`);
    }
    log.log(`Kiosk Mode is ${String(queryObj.kisokmode === 'enabled')}`);
    const logout = (reason, context) => {
        authLogout({ reason }, { context });
    };
    const getContentForInactivityCountdownDialog = () => (<DialogContent_1.default>
      <Typography_1.default variant="subtitle1">
        To ensure security of your session please confirm that you want to continue or you will be logged out automatically.
      </Typography_1.default>
      <exports.InactivityCountdown>
        {inactivityCountdownValue}
      </exports.InactivityCountdown>
    </DialogContent_1.default>);
    // Handle situation where user has already expired but this wasn't detected during our normal checks. This
    // is mostly likely to occur when user puts their system into hibernate mode and then comes back to it.
    const checkIfAlreadyExpired = (now) => {
        if (inactivityExpirationTime
            && now > inactivityExpirationTime
            && now > inactivityExpirationTime.plus({ seconds: inactivityCountdownTimeoutInSeconds })) {
            log.log('Already past expiration and countdown time, so logging out...');
            logout('AUTH_LOGOUT_INACTIVE', 'checkIfAlreadyExpired');
            return true;
        }
        return false;
    };
    const stopInactivityChecker = () => {
        if (inactivityExpirationChecker !== null) {
            clearInterval(inactivityExpirationChecker);
            inactivityExpirationChecker = null;
            inactivityExpirationTime = null;
        }
    };
    const stopInactivityCountdown = () => {
        if (inactivityCountdownUpdater) {
            clearInterval(inactivityCountdownUpdater);
            inactivityCountdownUpdater = null;
            inactivityCountdownValue = -1;
            inactivityCountdownDialogId = null;
        }
    };
    const inactivityCountdownContinueAction = () => {
        stopInactivityCountdown();
        startOrResetInactivityChecker(); // eslint-disable-line
    };
    const inactivityCountdownLogoutAction = () => {
        logout('AUTH_LOGOUT_USER_INITIATED', 'inactivityCountdownLogoutAction');
    };
    const startInactivityCountdown = () => {
        inactivityCountdownValue = inactivityCountdownTimeoutInSeconds;
        inactivityCountdownUpdater = setInterval(() => {
            if (checkIfAlreadyExpired(luxon_1.DateTime.local())) {
                return;
            }
            if (inactivityCountdownValue <= 0) {
                logout('AUTH_LOGOUT_INACTIVE', 'inactivityCountdownValue');
            }
            else {
                inactivityCountdownValue -= 1;
                updateDialogProps({
                    id: inactivityCountdownDialogId,
                    props: (0, immutable_1.Map)({ content: getContentForInactivityCountdownDialog() }),
                });
            }
        }, 1000);
        inactivityCountdownDialogId = (0, uuid_1.v4)();
        createDialog(root_ui_1.rootUiTypes.mkRootUiData({
            id: inactivityCountdownDialogId || '0',
            type: ConfirmationDialog_1.DIALOG_TYPE,
            allowNesting: true,
            props: (0, immutable_1.Map)((0, ConfirmationDialog_1.mkConfirmationDialogProps)({
                title: 'Session Inactivity',
                content: getContentForInactivityCountdownDialog(),
                confirmLabel: 'Continue',
                confirmAction: inactivityCountdownContinueAction,
                denyLabel: 'Logout',
                denyAction: inactivityCountdownLogoutAction,
                dialogCloseAliasAction: 'CONFIRM',
            })),
        }));
    };
    const startOrResetInactivityChecker = () => {
        const now = luxon_1.DateTime.local();
        if (checkIfAlreadyExpired(now)) {
            return;
        }
        inactivityExpirationTime = now.plus({ seconds: inactivityTimeoutInSeconds });
        if (inactivityExpirationChecker === null) {
            inactivityExpirationChecker = setInterval(() => {
                if (!inactivityCountdownUpdater) {
                    const nowInInactivityTimeoutChecker = luxon_1.DateTime.local();
                    if (inactivityExpirationTime && nowInInactivityTimeoutChecker >= inactivityExpirationTime) {
                        startInactivityCountdown();
                    }
                }
            }, 1000);
        }
    };
    const handleEvent = () => {
        if (inactivityExpirationChecker !== null && inactivityCountdownUpdater === null) {
            startOrResetInactivityChecker();
        }
    };
    if (!inKioskmode && isLoggedIn && inactivityExpirationChecker === null && !core_1.localPreferences.getKeepLoggedIn()) {
        startOrResetInactivityChecker();
    }
    else if ((inKioskmode || !isLoggedIn) && inactivityExpirationChecker !== null) {
        stopInactivityCountdown();
        stopInactivityChecker();
    }
    React.useEffect(() => {
        // Just once check to see if the version of the desktop version being used (for companion app) is
        // at the minumum version number supported for Mac and Windows.
        if (profile && !versionWarningGiven && checkDesktopMinVersion) {
            if ('product' in profile) {
                const clientType = (0, utils_1.safeRefIn)(profile, ['product', 'clientType']);
                let yourBuildNumber;
                let minBuildNumber;
                let numberField;
                let skipWarning = false;
                if (clientType === 'MAC') {
                    numberField = 'releaseNumber';
                    yourBuildNumber = (0, utils_1.safeRefIn)(profile, ['product', numberField]);
                    minBuildNumber = minMacReleaseNumber;
                    const fields = yourBuildNumber.split('.');
                    if (Number(fields[0]) === 0) {
                        skipWarning = true;
                    }
                }
                else {
                    numberField = 'buildNumber';
                    yourBuildNumber = (0, utils_1.safeRefIn)(profile, ['product', numberField]);
                    minBuildNumber = minWindowsBuildNumber;
                    // this sucks, windows build numbers are nonsensical, and I just have to hack through them
                    // if 2nd or 3rd field is zero, this is either a beta or dev build
                    const fields = yourBuildNumber.split('.');
                    if (Number(fields[1]) === 0 || Number(fields[2]) === 0) {
                        skipWarning = true;
                    }
                }
                const giveWarning = !skipWarning &&
                    !meetsMinimumVersionReqs(yourBuildNumber, minBuildNumber);
                log.log(`CHECKING DESKTOP VERSION .${clientType}. `, minBuildNumber, yourBuildNumber);
                if (giveWarning) {
                    props.showQHelp('upgradeVersion', Object.assign(Object.assign({}, (0, utils_1.safeRefIn)(profile, ['product'])), { minBuildNumber }));
                    versionWarningGiven = true;
                }
            }
        }
    }, [props, profile, checkDesktopMinVersion, minWindowsBuildNumber, minMacReleaseNumber]);
    return (<div id="main" onMouseOver={handleEvent} onFocus={handleEvent}>
      {props.children}
      <versionDisplay_1.default />
    </div>);
};
exports.default = (0, compose_1.default)((0, QHelp_1.default)())(React.memo(Main));
